import { useCallback as e, useState as O } from "react";
import { useControllableProp as P } from "./useControllable.js";
const k = (l = {}) => {
  const { onClose: p, onOpen: c, opened: f } = l, r = e(() => c?.(), [c]), a = e(() => p?.(), [p]), [C, i] = O(l.defaultIsOpen || !1), [o, n] = P(f, C), s = e(() => {
    o || i(!1), a?.();
  }, [o, a]), t = e(() => {
    o || i(!0), r?.();
  }, [o, r]), u = e(() => {
    (n ? s : t)();
  }, [n, t, s]);
  return {
    opened: n,
    onOpen: t,
    onClose: s,
    onToggle: u,
    isControlled: o
  };
};
export {
  k as useDisclosure
};
//# sourceMappingURL=useDisclosure.js.map
